import {
    MarketResearchCompensationData,
    MarketResearchDiversityData,
    MarketResearchSummaryData,
    MarketResearchSupplyDemandData,
    RelodeApiError,
} from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";
import { MarketResearchPublicOverviewData } from "apps/client/src/shared/types/marketResearchPublicOverviewData";

enum names {
    PUBLIC_MARKET_RESEARCH = "PUBLIC_MARKET_COMPENSATION",
    PUBLIC_MARKET_RESEARCH_SUCCESS = "PUBLIC_MARKET_COMPENSATION_SUCCESS",
    PUBLIC_MARKET_RESEARCH_FAILURE = "PUBLIC_MARKET_COMPENSATION_FAILURE",

    PUBLIC_MARKET_RESEARCH_COMPENSATION = "PUBLIC_MARKET_RESEARCH_COMPENSATION",
    PUBLIC_MARKET_RESEARCH_COMPENSATION_SUCCESS = "PUBLIC_MARKET_RESEARCH_COMPENSATION_SUCCESS",
    PUBLIC_MARKET_RESEARCH_COMPENSATION_FAILURE = "PUBLIC_MARKET_RESEARCH_COMPENSATION_FAILURE",

    PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND = "PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND",
    PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS = "PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS",
    PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE = "PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE",

    PUBLIC_MARKET_RESEARCH_DIVERSITY = "PUBLIC_MARKET_RESEARCH_DIVERSITY",
    PUBLIC_MARKET_RESEARCH_DIVERSITY_SUCCESS = "PUBLIC_MARKET_RESEARCH_DIVERSITY_SUCCESS",
    PUBLIC_MARKET_RESEARCH_DIVERSITY_FAILURE = "PUBLIC_MARKET_RESEARCH_DIVERSITY_FAILURE",

    PUBLIC_MARKET_RESEARCH_SUMMARY = "PUBLIC_MARKET_RESEARCH_SUMMARY",
    PUBLIC_MARKET_RESEARCH_SUMMARY_SUCCESS = "PUBLIC_MARKET_RESEARCH_SUMMARY_SUCCESS",
    PUBLIC_MARKET_RESEARCH_SUMMARY_FAILURE = "PUBLIC_MARKET_RESEARCH_SUMMARY_FAILURE",

    PUBLIC_MARKET_RESEARCH_OVERVIEW = "PUBLIC_MARKET_RESEARCH_OVERVIEW",
    PUBLIC_MARKET_RESEARCH_OVERVIEW_SUCCESS = "PUBLIC_MARKET_RESEARCH_OVERVIEW_SUCCESS",
    PUBLIC_MARKET_RESEARCH_OVERVIEW_FAILURE = "PUBLIC_MARKET_RESEARCH_OVERVIEW_FAILURE",
}

export default names;

export const creators = {
    loadMarketResearch: () => createAction(names.PUBLIC_MARKET_RESEARCH),
    loadMarketResearchSuccess: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUCCESS),
    loadMarketResearchFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_FAILURE, {
            error,
        }),

    loadMarketResearchCompensation: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_COMPENSATION),

    loadMarketResearchCompensationSuccess: (
        data: MarketResearchCompensationData
    ) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_COMPENSATION_SUCCESS, {
            data,
        }),
    loadMarketResearchCompensationFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_COMPENSATION_FAILURE, {
            error,
        }),

    loadMarketResearchSupplyDemand: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND),
    loadMarketResearchSupplyDemandSuccess: (
        data: MarketResearchSupplyDemandData
    ) => createAction(names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS, { data }),
    loadMarketResearchSupplyDemandFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE, { error }),

    loadMarketResearchDiversity: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_DIVERSITY),
    loadMarketResearchDiversitySuccess: (data: MarketResearchDiversityData) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_DIVERSITY_SUCCESS, { data }),
    loadMarketResearchDiversityFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_DIVERSITY_FAILURE, { error }),

    loadMarketResearchOverview: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_OVERVIEW),
    loadMarketResearchOverviewSuccess: (
        data: MarketResearchPublicOverviewData
    ) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_OVERVIEW_SUCCESS, {
            data,
        }),
    loadMarketResearchOverviewFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_OVERVIEW_FAILURE, { error }),

    loadMarketResearchSummary: () =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUMMARY),
    loadMarketResearchSummarySuccess: (data: MarketResearchSummaryData) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUMMARY_SUCCESS, { data }),
    loadMarketResearchSummaryFailure: (error: RelodeApiError) =>
        createAction(names.PUBLIC_MARKET_RESEARCH_SUMMARY_FAILURE, { error }),
};

export type ClientPublicMarketResearchActionTypes = ActionsUnion<
    typeof creators
>;
